function playVideo(videoElement) {
    if (videoElement) {
        videoElement.play();
    }
}

function toggleMute(button, videoElement) {
    const muteIcon = button.querySelector('.mute-icon');
    const unmuteIcon = button.querySelector('.unmute-icon');

    if (videoElement.muted) {
        videoElement.muted = false;
        muteIcon.style.display = 'none';
        unmuteIcon.style.display = 'block';
    } else {
        videoElement.muted = true;
        muteIcon.style.display = 'block';
        unmuteIcon.style.display = 'none';
    }
}


function initializeSwiper() {
    var swiper = new Swiper(".mySwiper", {
        slidesPerView: 4,
        spaceBetween: 5,
        centeredSlides: true,
        loop: true,
        breakpoints: {
            0: {
               slidesPerView: 1.75,
                spaceBetween: 5,
            },
            480: {
                slidesPerView: 1.75,
                spaceBetween: 5,
            },
            640: {
                slidesPerView: 2,
                spaceBetween: 5,
            },
            768: {
                slidesPerView: 2.5,
                spaceBetween: 5,
            },
            1024: {
                slidesPerView: 3.5,
                spaceBetween: 5,
            },
            1280: {
                slidesPerView: 4,
                spaceBetween: 5,
            },
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        on: {
            init: function () {
                console.log('Swiper initialized');
                var activeSlide = document.querySelector('.swiper-slide-active .vs-video');
                if (activeSlide) {
                    console.log('Active slide video found');
                    playVideo(activeSlide);
                } else {
                    console.log('No active slide video found');
                }
            },
            slideChangeTransitionEnd: function () {
                console.log('Slide changed');
                var videos = document.querySelectorAll('.vs-video');
                videos.forEach(video => {
                    video.pause();
                });
                var activeSlide = document.querySelector('.swiper-slide-active .vs-video');
                if (activeSlide) {
                    playVideo(activeSlide);
                }
            }
        }
    });

    document.querySelectorAll('.mute-button').forEach(button => {
        button.addEventListener('click', function() {
            var videoElement = this.closest('.M-video-slider-video').querySelector('.vs-video');
            toggleMute(this, videoElement);
        });
    });
  }

let coll = document.getElementsByClassName("collapsible");
let i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function() {
    this.classList.toggle("active");
    let content = this.nextElementSibling;
    if (content.style.maxHeight){
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    }
  });
   if (coll[i].classList.contains("reviewscollapsible")) {
    coll[i].click(); 
  }
}


initslide();

$(document).on('shopify:section:load', function(event) {
  initslide();
});

$(document).on('shopify:section:unload', function(event) {
  $('.M-trustpilot-slider').slick('unslick');
});
function initslide() {
$('.M-trustpilot-block-slider').slick({
   infinite: true,
   slidesToShow: 2,
   slidesToScroll: 1,
   autoplay: true,
   autoplaySpeed: 3000,
     prevArrow:"<button type='button' class='slick-prev Mtp-left'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 320 512'><path d='M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z'/></svg></button>",
    nextArrow:"<button type='button' class='slick-next Mtp-right'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 320 512'><path d='M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z'/></svg></button>",
  responsive: [
   {
      breakpoint: 900,
      settings: {
        arrows: true,
        centerPadding: '40px',
        slidesToShow: 1
      }
   },
   {
      breakpoint: 600,
      settings: {
        arrows: true,
        centerPadding: '40px',
        slidesToShow: 1
      }
   }
  ]
  });
}

function handleUpcartToggle(retryCount = 0, maxRetries = 20) {
  setTimeout(() => {
    const shadowHosts = document.querySelectorAll('*');
    let toggleSwitch = null;
    
    for (let host of shadowHosts) {
      if (host.shadowRoot) {
        toggleSwitch = host.shadowRoot.querySelector('.upcart-internal-addons__toggle-switch input[type="checkbox"]');
        
        if (!toggleSwitch) {
          toggleSwitch = host.shadowRoot.querySelector('.upcart-public-addons__toggle-switch input[type="checkbox"]');
        }
        
        if (!toggleSwitch) {
          toggleSwitch = host.shadowRoot.querySelector('input[role="switch"]');
        }
        
        if (toggleSwitch) break;
      }
    }
    
    if (toggleSwitch) {
      const isChecked = toggleSwitch.getAttribute('aria-checked') === 'true';
      
      if (!isChecked) {
        const label = toggleSwitch.closest('label');
        if (label) {
          label.click();
        } else {
          toggleSwitch.click();
        }
      }
    } else {
      if (retryCount < maxRetries) {
        handleUpcartToggle(retryCount + 1, maxRetries);
      }
    }
  }, retryCount === 0 ? 500 : 200);
}

window.addEventListener('aftersell-upcart:public-events:cart-opened', handleUpcartToggle);
document.addEventListener('DOMContentLoaded', handleUpcartToggle);